const Header = () => (
    <nav className="header">
        <img className="logo" src="/logo192.png" alt="logo"/>
        <h1 className="title">Code Haven</h1>
    </nav>
);

export default Header;
